import { default as BSToast } from 'bootstrap/js/src/toast'

class Toast extends BSToast {}

export default Toast
